import client from './client';

/**
 * 키셋 페이징 조회. params: searchStartDate/searchEndDate(필수), orderStatus, memberAccount, cursor, pageSize
 */
export async function getOrderList(params) {
  const res = await client.get('/admin/order', { params });
  return res.data;
}

export async function getOrder(orderId, orderDate) {
  const res = await client.get(`/admin/order/${orderId}`, { params: { orderDate } });
  return res.data;
}

/** 테스트/데모용 주문 생성 (실제 주문 플로우가 아직 없어 임시 제공) */
export async function createOrder(payload, createdBy) {
  const res = await client.post('/admin/order', payload, { params: { createdBy } });
  return res.data;
}

export async function updateOrderStatus(orderId, orderDate, orderStatus, updatedBy) {
  const res = await client.put(`/admin/order/${orderId}/status`, { orderDate, orderStatus, updatedBy });
  return res.data;
}
